import { render, staticRenderFns } from "./minisaticieklecomp.vue?vue&type=template&id=bc9bffcc"
import script from "./minisaticieklecomp.vue?vue&type=script&lang=js"
export * from "./minisaticieklecomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports